/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  MockVault,
  MockVaultInterface,
} from "../../../contracts/mock/MockVault";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "side",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "FundsDeposited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "side",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bool",
        name: "isEarly",
        type: "bool",
      },
    ],
    name: "FundsWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "timeEnded",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "VaultEnded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "timeStarted",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "VaultStarted",
    type: "event",
  },
  {
    inputs: [],
    name: "adapter",
    outputs: [
      {
        internalType: "contract AdapterBase",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimToken",
    outputs: [
      {
        internalType: "contract VaultBearerToken",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "side",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "duration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "earningsSettled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "endTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeBps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeReceiver",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "fixedBearerToken",
    outputs: [
      {
        internalType: "contract VaultBearerToken",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "fixedSideCapacity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_vaultId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_duration",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_adapterAddr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_fixedSideCapacity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_variableSideCapacity",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_variableAsset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_feeBps",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_feeReceiver",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "initialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isStarted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "variableAsset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "variableBearerToken",
    outputs: [
      {
        internalType: "contract VaultBearerToken",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "variableSideCapacity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vaultId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "side",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type MockVaultConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MockVaultConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MockVault__factory extends ContractFactory {
  constructor(...args: MockVaultConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<MockVault> {
    return super.deploy(overrides || {}) as Promise<MockVault>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): MockVault {
    return super.attach(address) as MockVault;
  }
  override connect(signer: Signer): MockVault__factory {
    return super.connect(signer) as MockVault__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MockVaultInterface {
    return new utils.Interface(_abi) as MockVaultInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockVault {
    return new Contract(address, _abi, signerOrProvider) as MockVault;
  }
}
